import $ from "cash-dom";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    var selector = ".swiper";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_slider.js initialized", "green");

        var spaceBetween = getCssVarValue("--blh") * 1.5;
        var speed = getCssVarValue("--duration-md");

        $(selector).each(function () {
            var $instance = $(this);
            var autoplay;
            var autoplayDuration = 3200;
            var userHasClicked = false;

            new Swiper($instance[0], {
                centeredSlides: true,
                spaceBetween: spaceBetween,
                // slidesOffsetBefore: indent,
                // slidesOffsetAfter: indent,
                slidesPerView: "auto",
                speed: speed,
                // autoHeight: true,
                modules: [Navigation, Pagination],
                // loop: false,
                allowTouchMove: true,
                disabledClass: "pointer-none",
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: "[data-next]",
                    prevEl: "[data-prev]",
                },
                on: {
                    slideChange: slideChangeHandler,
                },
            });

            $instance
                .parents(".layout")
                .find("[data-description]")
                .each(function (_i, _el) {
                    var $clone = $(this).clone();

                    $clone.removeClass("hide").addClass("fade-in transition-md");
                    if (_i == 0) $clone.addClass("on");

                    $instance.parents(".layout").find(".description-wrapper").append($clone);
                });
        });
    }

    function slideChangeHandler(_Swiper) {
        var $instance = $(_Swiper.el);

        $instance.parents(".layout").find(".description-wrapper .description").removeClass("on");
        $instance.parents(".layout").find(".description-wrapper .description").eq(_Swiper.activeIndex).addClass("on");
    }

    $(document).ready(init);
})();
